module.exports = __webpack_public_path__ + "img/product-feature-txt-bg3.76f665dc.png";